var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBorder3TopLeft = function SvgBorder3TopLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 321,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 1H30.5C13.931 1 .5 14.431.5 31v289.5",
    stroke: "#000"
  })));
};

export default SvgBorder3TopLeft;